__turbopack_context__.v({
  "headline": "LiveblogIntro-module-scss-module__1ynYoG__headline",
  "liveblogBagde": "LiveblogIntro-module-scss-module__1ynYoG__liveblogBagde",
  "liveblogBagde__lastUpdated": "LiveblogIntro-module-scss-module__1ynYoG__liveblogBagde__lastUpdated",
  "liveblogBagde__live": "LiveblogIntro-module-scss-module__1ynYoG__liveblogBagde__live",
  "liveblogIntro": "LiveblogIntro-module-scss-module__1ynYoG__liveblogIntro",
  "liveblogIntro__header": "LiveblogIntro-module-scss-module__1ynYoG__liveblogIntro__header",
  "liveblogIntro__image": "LiveblogIntro-module-scss-module__1ynYoG__liveblogIntro__image",
  "liveblogIntro__summary": "LiveblogIntro-module-scss-module__1ynYoG__liveblogIntro__summary",
  "liveblogIntro__summaryPoints": "LiveblogIntro-module-scss-module__1ynYoG__liveblogIntro__summaryPoints",
  "liveblogIntro__summaryWrapper": "LiveblogIntro-module-scss-module__1ynYoG__liveblogIntro__summaryWrapper",
});
